// extracted by mini-css-extract-plugin
module.exports = {"root":"Alert_root___aHRC","heading":"Alert_heading__3iXiO","content":"Alert_content__3pSzJ","warning":"Alert_warning__Y5Wll","danger":"Alert_danger__1kl0s"};